import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AppDispatch, CustomerInterface } from "src/common";

// ============ INTERFACE ============

export interface CustomerStateInterface {
  data: CustomerInterface;
}

// ============ INIT STATE ============

const initialState: CustomerStateInterface = {
  data: {}
};

// ========= SLICE ==========

export const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomer: (state: CustomerStateInterface, action: PayloadAction<CustomerInterface>) => {
      state.data = {
        ...state.data,
        ...action.payload
      };
    },
    clearCustomer: (state: CustomerStateInterface) => {
      state.data = {};
    }
  }
})

export const { setCustomer, clearCustomer } = customerSlice.actions;

export default customerSlice.reducer;

export const saveCustomer = (data: CustomerInterface) => (dispatch: AppDispatch) => {
  dispatch(setCustomer(data));
};
